module.exports = __webpack_public_path__ + "img/undraw_Prototyping_process_re_7a6p.314a17d9.png";